export default "__VITE_ASSET__lKcEbNCY__"